import { getFullName } from '../account';
import { formatDate } from '../formatDate';

import { IExpertiseResponse } from 'services/expertise/expertise.interface';
import { IExpertise } from 'views/pages/ExpertiseManagement/expertise-management.interface';

function convertExpertiseToDetailsView(expertise: IExpertiseResponse): IExpertise {
  const {
    id,
    name,
    description,
    isPublished,
    accountUpdated,
    updated,
    created,
    accountCreated,
    organization,
    industry,
  } = expertise;
  return {
    id,
    name,
    description,
    isPublished,
    organization,
    industryName: industry.name,
    updatedDate: updated ? formatDate(updated) : formatDate(created),
    createdDate: formatDate(created!),
    accountUpdatedBy: accountUpdated
      ? getFullName(accountUpdated.firstName, accountUpdated.lastName)
      : getFullName(accountCreated.firstName, accountCreated.lastName),
    accountCreatedBy: getFullName(accountCreated.firstName, accountCreated.lastName),
  };
}

export { convertExpertiseToDetailsView };
